import React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { ButtonTertiary, MeatballMenu } from 'ui';
import { MdExpandLess, MdExpandMore } from 'react-icons/md';
import { CodeMappingTileWrapperProps } from 'app/area/code-mappings/components/types';
import styles from './code-mapping-tile-wrapper.scss';

interface CodeMappingTileWrapperState {
  toggle: boolean;
}
export class CodeMappingTileWrapper extends React.PureComponent<CodeMappingTileWrapperProps, CodeMappingTileWrapperState> {

  public readonly state: Readonly<CodeMappingTileWrapperState> = { toggle: true };

  public componentDidMount() {
    if (this.props.codetableIndex === 0) {
      this.loadPerCodetable();
    }
  }

  private loadPerCodetable = () => {
    this.changeState();
    this.loadList();
  };

  private changeState = () => {
    this.setState({ toggle: !this.state.toggle });
  };

  private loadList = () => {
    this.props.loadItem(this.props.id, { codetableId: this.props.codetableId, codetablesOnly: false });
  };

  private onClick = () => {
    if (!!this.props.fetchingItemId) {
      return;
    }
    this.props.isLoaded ? this.changeState() : this.loadPerCodetable();
  };

  public render() {
    const { importSetId, codetableId, description, children, translation } = this.props;
    const { toggle } = this.state;

    const handleMissingCodes = () => navigate.toImportMappingsList(importSetId, codetableId);

    return <div className={styles.tileContainer}>
      <div className={styles.tile}>
        <div className={`${styles.tileHeader} ${toggle ? styles.inactive : ''}`}>
          <div>
            <ButtonTertiary classNames={styles.toggleButton} onClick={this.onClick}>
              {toggle
                ? <MdExpandMore className={styles.icon} />
                : <MdExpandLess className={styles.icon} />
              } <span className={styles.title}>{description}</span>
            </ButtonTertiary>
          </div>

          <MeatballMenu>
            <button type="button" className="dropdown-item" onClick={handleMissingCodes}>
              {translation.view_all_mappings}
            </button>
          </MeatballMenu>
        </div>
        {!toggle ? children : null}
      </div>
    </div>;
  }
}
